import { array, InferOutput, literal, object } from 'valibot'
import { ArmorSchema } from '../../Armor.type'
import { AttackedThisTurnSchema } from '../../AttackedThisTurn'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { entityTypeDefaults, EntityTypeMeta } from '../../EntityTypeMeta'
import { FuelSchema } from '../../fuel.type'
import { HasMobilitySchema } from '../../has_mobility'
import { HasXYSchema } from '../../has_xy'
import { HPSchema } from '../../hp.type'
import { PlayerIdOrNullSchema } from '../../player/PlayerIdOrNull'
import { VisionSchema } from '../../vision.type'
import { WasBuiltThisTurnSchema } from '../../WasBuiltThisTurn'
import { ArmorTypeId } from '../Armor/ArmorTypeId.enum'
import { BaseEntitySchema } from '../BaseEntity'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'
import { MoveTypeId } from '../move_type_id.enum'
import createVehicleMachineGunWeapon from '../Weapon/createVehicleMachineGunWeapon'
import { WeaponSchema } from '../Weapon/Weapon.type'

const entDefaults = {
  etype_id: EntityTypeId.LightRecon,
  layer_id: EntityLayerId.Unit2,
  hp: 10,
  fuel: 80,
  vision: 5,
  mtype_id: MoveTypeId.Tires,
  mobility: 8,
  armor: 5,
} as const

function defaultWeapons() {
  return [createVehicleMachineGunWeapon(4)]
}

export const LightReconEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.LightRecon),
  layer_id: literal(EntityLayerId.Unit2),
  id: EntityIdSchema,
  player_id: PlayerIdOrNullSchema,
  hp: HPSchema,
  fuel: FuelSchema,
  vision: VisionSchema,
  armor: ArmorSchema,
  ...HasXYSchema.entries,
  ...HasMobilitySchema.entries,
  builtThisTurn: WasBuiltThisTurnSchema,
  attackedThisTurn: AttackedThisTurnSchema,
  weapons: array(WeaponSchema),
})

export type LightReconEntity = InferOutput<typeof LightReconEntitySchema>

/**
 * Fast, lightly-armored vehicle equipped with advanced optics for battlefield reconnaissance.
 */
export const LightReconEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.LightRecon,
  dname: 'Recon',
  layer_id: EntityLayerId.Unit2,
  group_id: EntityTypeGroupId.Unit,
  entDefaults,
  price: 40,
  defaultWeapons,
  armor_type: ArmorTypeId.LightVehicle,
}

export function createLightReconEntity(
  id: number,
  x: number,
  y: number,
  player_id: number | null
): LightReconEntity {
  return {
    ...entDefaults,
    heading: 0,
    weapons: defaultWeapons(),
    id,
    x,
    y,
    player_id,
  }
}
